import keyMirror from 'keymirror';

const FORMS_OF_PAYMENT = keyMirror({
  CREDIT: null,
  PAYPAL: null,
  GIFT_CARD: null,
  REMOTE: null,
  VISA_CHECKOUT: null,
  MASTERPASS: null,
  EMD_VOUCHER: null,
});

export default FORMS_OF_PAYMENT;
